import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=3b30f468&scoped=true&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=3b30f468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30f468",
  null
  
)

export default component.exports